<template>
  <div>
    <v-app-bar app fixed >
      <div class="d-none d-lg-flex">
        <v-btn @click="emitChanges" icon >
          <v-icon>mdi-menu</v-icon>
        </v-btn>
        <!--<img alt="Vue Material Admin" class="pr-5" src="../assets/bsn.png" style="max-height: 50px">-->
      </div>
      <div class="d-flex d-lg-none">
        <v-btn @click="emitChangesSidebar" icon >
          <v-icon>mdi-menu</v-icon>
        </v-btn>
        <v-col cols="auto">
          <!--<img alt="Vue Material Admin" src="../assets/cgc.png" height= 30px>-->
        </v-col>
      </div>
      <v-spacer/>
      <div class="d-none d-sm-flex">
        <v-tooltip bottom >
          <template v-slot:activator="{ on }">
            <v-card class="text-left" text height="48px" v-on="on" flat>
              <v-simple-table dense>
                <tr>
                  <td class="title d-inline-block text-truncate" width="250px">Name: {{ name }}</td>
                </tr>
                <tr>
                  <td class="subtitle-1 d-inline-block" width="250px">Branch : {{ branch }} </td>
                </tr>
              </v-simple-table>
           </v-card>
          </template>
          <v-row>
            <span class="title text-wrap">Name : {{ name }}</span>
          </v-row>
          <v-row>
            <span class="subtitle-1">Branch : {{ branch }}</span>
          </v-row>
        </v-tooltip>
        <v-dialog v-model="handleLogoutMenuMobile" persistent max-width="290">
          <template v-slot:activator="{ on }">
            <v-btn style="margin-top:5px" color="primary" v-on="on">Log out</v-btn>
          </template>
          <v-card>
            <v-card-title>Logout</v-card-title>
            <v-card-text>
              Are you sure, you want to log out?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="handleLogoutMenuMobile = false">Cancel</v-btn>
              <v-btn @click="handleLogout" color="primary">Yes</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <div class="d-flex d-sm-none">
        <v-tooltip bottom v-model="show">
          <template v-slot:activator="{ on }">
            <v-card small text v-on="on" style="margin-right:20px" flat><v-icon>mdi-account</v-icon></v-card>
          </template>
          <v-row>
            <td class="title text-wrap">Name : {{ name }}</td>
          </v-row>
          <v-row>
            <td class="subtitle-1">Branch : {{ branch }}</td>
          </v-row>
        </v-tooltip>
        <div class="text-center">
          <v-dialog v-model="handleLogoutMenuMobile" persistent max-width="290">
            <template v-slot:activator="{ on }">
              <v-btn style="margin-top:0px" color="primary" v-on="on" small>Log out</v-btn>
            </template>
            <v-card>
              <v-card-title>Logout</v-card-title>
                <v-card-text>
                  Are you sure, you want to log out?
                </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="handleLogoutMenuMobile = false">Cancel</v-btn>
                <v-btn @click="handleLogout" color="primary">Yes</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </v-app-bar>
  </div>
</template>

<script>
  import { EventBus } from '../main'
  // import MobileHeader from '../components/MobileHeader'

  export default {
    components: {
      // MobileHeader
    },
    name: 'PostLoginHeader',
    data(){
      return {
        handleLogoutMenuMobile: false,
        show: false,
        name: "Farah",
        branch: "Main",
      }
    },
    methods: {
      handleLogout: function () {
        this.$router.push('/')
      },
      emitChanges: function () {
        EventBus.$emit('Clicked')
      },
      emitChangesSidebar: function () {
         EventBus.$emit('Sidebar')
      }
    }
  }
</script>

<style>

  .colorPrimary {
    color: #2196F3!important;
  }

</style>
